import { Injectable, ErrorHandler } from '@angular/core';

import * as Sentry from '@sentry/browser';

import { AppConstants } from '@apps/app.constants';

@Injectable({
    providedIn: 'root'
})
export class SentryErrorHandler implements ErrorHandler
{
    handleError (error: any)
    {
        if (AppConstants.Configuration.sentryDsn)
        {
            Sentry.captureException(error.originalError || error.error || error);
        }

        // Sans cela, toute exception d'execution etait avalee silencieusement : ni log, ni popin,
        // ni message en console (le handler global remplace celui d'Angular). Le DSN Sentry n'est
        // renseigne que sur les environnements equipes, ce qui rendait le developpement local muet.
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
